import { Box, Typography } from "@mui/material";
import NoListing from "../assets/empty.png";

const Listings = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        pt: 1,
      }}
    >
      <img src={NoListing} alt='no-listing' style={{ width: "110px" }} />
      <Typography>No listing yet</Typography>
    </Box>
  );
};

export default Listings;
